<template class="full-height">
  <div class="faultBack-app-container" style="position: relative; height: 100%; padding: 15px">
    <el-card v-if="isTravel" class="box-card" style="">
      <el-form ref="form" v-loading="formLoading" :model="formData">
        <el-form-item
          label="標題大綱"
          :label-width="formLabelWidth"
          prop="title"
          :rules="[{ required: true, message: '請輸入標題大綱', trigger: 'blur' }]"
        >
          <el-input
            v-model="formData.title"
            autocomplete="off"
            maxlength="100"
            show-word-limit
            placeholder="請簡單描述..."
          />
        </el-form-item>

        <el-form-item
          label="詳細內容"
          :label-width="formLabelWidth"
          prop="describe"
          :rules="[{ required: true, message: '請輸入詳細內容', trigger: 'blur' }]"
        >
          <el-input
            type="textarea"
            v-model="formData.describe"
            :autosize="{ minRows: 8, maxRows: 10 }"
            placeholder="請詳細輸入內容，您的回饋是我們最大的進步動力！"
          ></el-input>
        </el-form-item>

        <el-form-item label="截圖畫面" :label-width="formLabelWidth">
          <div>
            <Upload
              ref="uploadRef"
              :accept="'.jpg,.jpeg,.png'"
              :payload="formData"
              :limitText="'如有錯誤畫面請截圖提供給我們以利系統修正，圖片須為.jpg,.jpeg,.png格式，限制不超過2000MB'"
              :data-obj="fileObj"
              :limit-file-count="3"
              :use-drag="false"
              :action="'appManage/saveFaultBack'"
              :auto-upload="false"
              :show-file-list="true"
              :form-on-loading-parent="formLoading"
              :btn-txt="'上傳'"
              :before-file-list="
                formData.fileInfo && formData.fileInfo.length ? formData.fileInfo[0].files : []
              "
            />
          </div>
        </el-form-item>
        <el-form-item style="text-align: right">
          <el-button type="warning" @click="submitForm('form')" style="color: #4b4b4b"
            >儲 存</el-button
          >
          <el-button @click="resetForm()">取 消</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <el-form v-if="!isTravel" :inline="true" class="filter-form">
      <el-form-item label="團號">
        <el-input v-model="listQuery.qry" placeholder="輸入團號" />
      </el-form-item>

      <el-button
        type="primary"
        @click="getList"
        icon="el-icon-search"
        circle
        style="margin-top: 8px; margin-left: 5px"
        :disabled="listLoading"
      ></el-button>
      <el-button
        style="cursor: pointer"
        type="success"
        :loading="listLoading"
        circle
        icon="el-icon-refresh-left"
        @click="refresh()"
      ></el-button>
    </el-form>

    <div v-if="!isTravel" style="position: relative; height: 80%">
      <el-table
        v-loading="listLoading"
        :data="list"
        size="mini"
        border
        fit
        highlight-current-row
        style="width: 100%"
        height="100%"
      >
        <el-table-column align="center" label="ID" width="40">
          <template slot-scope="{ row }">
            <span>{{ row.id }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="團號" width="200">
          <template slot-scope="{ row }">
            <span>{{ row.tourGroupNo }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="提交人" width="200">
          <template slot-scope="{ row }">
            <span>{{ row.buildUser }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="畫面" width="100">
          <template slot-scope="scope">
            <el-image
              v-if="scope.row.fileInfo !== null && scope.row.fileInfo.length > 0"
              style="height: 50px"
              :src="
                scope.row.fileInfo !== null && scope.row.fileInfo.length > 0
                  ? scope.row.fileInfo[0].files[0].url
                  : 'https://fakeimg.pl/280x160/'
              "
              fit="contain"
              :preview-src-list="fileUrl(scope.row.fileInfo)"
            ></el-image>
            <span v-else>無</span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="標題大綱" width="200">
          <template slot-scope="{ row }">
            <span>{{ row.title }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="詳細內容" width="350">
          <template slot-scope="{ row }">
            <el-input :rows="6" type="textarea" disabled :value="row.describe"></el-input>
          </template>
        </el-table-column>

        <el-table-column align="center" label="建立時間" sortable="custom" width="120">
          <template slot-scope="{ row }">
            <span>{{ dataTime(row.buildDate) }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="更新時間" sortable="custom" width="120">
          <template slot-scope="{ row }">
            <span>{{ dataTime(row.updateDate) }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="更新人" width="120">
          <template slot-scope="{ row }">
            <span>{{ row.updateUser }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="編輯">
          <template slot-scope="scope">
            <el-button
              type="primary"
              size="mini"
              class="filter-item"
              @click="editData(scope.row)"
              :disabled="scope.row.isSolved"
              >標記</el-button
            >
          </template>
        </el-table-column>

        <el-table-column align="center" :label="'刪除'">
          <template slot-scope="scope">
            <el-button size="mini" class="filter-item" type="danger" @click="deleteData(scope.row)">
              刪除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <pagination
      v-show="total > 0"
      layout="total, prev, pager, next"
      :total="total"
      :page.sync="listQuery.page"
      :limit.sync="listQuery.limit"
      @pagination="getList"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Upload from '@/views/ita/components/fileUpload.vue'
import Pagination from '@/components/Pagination'
import { dateFormat } from '@/utils'
import {
  deleteFaultBack,
  getFaultBack,
  getNotSolveFaultBack,
  saveFaultBack,
  saveSolvedFaultBack,
} from '@/api/appManage'
import { Message } from 'element-ui'

var defaultForm = {
  id: null,
  fileInfo: [], //照片
  title: '',
  describe: '',
}

export default {
  name: 'FaultBack',
  computed: {
    ...mapGetters(['roles']),
    dataTime() {
      return function (value) {
        return value
        //return dateFormat(value);
      }
    },
    fileUrl() {
      return function (array) {
        if (array == null) {
          return ['https://fakeimg.pl/280x160/']
        }
        if (array.length) {
          var list = array[0].files.map(x => {
            return x.url
          })
          return list
        } else {
          return ['https://fakeimg.pl/280x160/']
        }
      }
    },
  },
  components: { Pagination, Upload },
  data() {
    return {
      isTravel: false,
      formLabelWidth: '120px',
      formLoading: false,
      fileObj: { id: 0, type: 'agencyInfo', user: '' },
      formData: {},
      listLoading: false,
      list: [],
      listQuery: {
        qry: '',
        date: '',
        status: null,
        page: 1,
        limit: 20,
        sort: '+isSolved,-BuildDate',
      },
      total: 0,
      agencyCode: null,
    }
  },
  async mounted() {
    this.agencyCode = this.$store.getters.userInfo.agencyCode
      ? this.$store.getters.userInfo.agencyCode
      : null
    if (this.agencyCode !== null) {
      this.isTravel = true
      this.formData = JSON.parse(JSON.stringify(defaultForm))
    } else {
      await this.getList()
    }
  },
  methods: {
    async refresh() {
      this.listQuery = {
        qry: '',
        date: '',
        status: null,
        page: 1,
        limit: 20,
        sort: '+isSolved,-BuildDate',
      }
      await this.getList()
    },
    submitForm(formName) {
      let vm = this
      if (this.agencyCode == null) {
        this.$message.error('尚未取得旅行社代碼')
        return false
      }
      if (!confirm(`確定要儲存該筆資料?`)) {
        return false
      }
      vm.formLoading = true
      let refUpload = this.$refs['uploadRef']
      this.$refs[formName].validate(async valid => {
        if (valid) {
          let payload = await refUpload.combineFileAndPayload()
          if (!payload) {
            this.$message.error('檔案繫結表單發生未知錯誤，無法儲存資料。')
            vm.formLoading = false
            return false
          }
          payload.tourGroupNo = this.agencyCode
          await saveFaultBack(payload)
            .then(res => {
              vm.resetForm()
              vm.formLoading = false
              Message({
                message: '提交成功',
                type: 'success',
                duration: 5 * 1000,
              })
            })
            .catch(err => {
              console.log(err)
            })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    resetForm() {
      let refUpload = this.$refs['uploadRef']
      refUpload.clearFiles()
      this.$refs['form'].clearValidate()
      this.formData = JSON.parse(JSON.stringify(defaultForm))
    },
    async getList() {
      let vm = this
      vm.listLoading = true
      await getFaultBack(this.listQuery).then(response => {
        console.log(response)
        vm.listLoading = false
        this.list = response.data.data
        this.total = response.data.total
        var notSolve = this.list.filter(x => x.isSolved == false).length
        this.$store.dispatch('app/setFaultBackCount', notSolve)
      })
    },
    editData(row) {
      let vm = this
      this.$confirm('確認是否要標記已解決?', '確認', {
        confirmButtonText: '確定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          this.listLoading = true
          //更新isSolved
          await saveSolvedFaultBack(row.id)
            .then(async res => {
              await vm.getList()
              vm.listLoading = false
              Message({
                message: '資料處理完成',
                type: 'success',
                duration: 5 * 1000,
              })
            })
            .catch(err => {
              console.log(err)
            })
        })
        .catch(() => {})
    },
    async deleteData(row) {
      let vm = this
      if (confirm(`確定刪除該則故障與回饋?\r\n`)) {
        vm.$message({
          message: '操作成功',
          type: 'success',
        })
        vm.listLoading = true
        let resp = await deleteFaultBack({ id: row.id })
        if (resp.success) {
          await vm.getList()
          vm.$message({
            message: '操作成功',
            type: 'success',
          })
        }
        vm.listLoading = false
      }
    },
  },
}
</script>
<style>
.full-heigth {
  position: relative;
  height: 100%;
}

.el-dialog__body {
  padding-top: 0px;
}
</style>
